import medicinesClientService from "../../../services/medicine-client/medicine-client.js";
import i18n from "../../../i18n/index";

export default {
  data() {
    return {
      search: "",
      headers: [
        { text: "COD GEN ZENTRIA", sortable: false, value: "codGenZentria" },
        {
          text: "Descripción genérica",
          sortable: false,
          value: "descripcionGenericaZentria",
        },
        { text: "COD HOM EVEDISA", sortable: false, value: "codHomEvedisa" },
        { text: "Código", sortable: false, value: "codigo" },
        { text: "Código barras", sortable: false, value: "codBarras" },
        { text: "Descripción", sortable: false, value: "descripcion" },
        { text: "CUM", sortable: false, value: "cum" },
        {
          text: "UND mín. presentación",
          sortable: false,
          value: "undMinPresentacion",
        },
        { text: "Contenido", sortable: false, value: "contenido" },
        {
          text: "Código barras Evedisa",
          sortable: false,
          value: "codBarrasEvedisa",
        },
        { text: "PLU", sortable: false, value: "pluCode" },
        { text: "Activo", sortable: false, value: "active" },
      ],
      itemsData: [],
      nroRows: 0,
    };
  },
  mounted() {
    this.searchCity();
  },
  methods: {
    onRowClick(item) {
      this.$emit("row-click", item);
    },
    async searchCity() {
      try {
        const response = await medicinesClientService.getAll();
        const data = response && response.data ? response.data : response || [];
        this.itemsData = Array.isArray(data) ? data : [];
        this.nroRows = this.itemsData.length;
      } catch (e) {
        this.itemsData = [];
        this.nroRows = 0;
        if (this.$notify) {
          this.$notify({
            group: "app",
            type: "error",
            text: i18n.t("app.unexpected-error"),
          });
        }
      }
    },
    getLenght() {
      return this.nroRows;
    },
    customFilter(items, search /*, filter */) {
      if (!search) return items;
      const term = String(search).toLowerCase();
      return items.filter(function (row) {
        var fields = [
          row.codGenZentria,
          row.descripcionGenericaZentria,
          row.codHomEvedisa,
          row.codigo,
          row.codBarras,
          row.descripcion,
          row.cum,
          row.undMinPresentacion,
          row.contenido,
          row.codBarrasEvedisa,
          row.pluCode,
          row.active ? "si" : "no",
        ];
        fields = fields
          .filter(function (v) {
            return v !== null && v !== undefined;
          })
          .map(function (v) {
            return String(v).toLowerCase();
          });
        return fields.some(function (f) {
          return f.indexOf(term) !== -1;
        });
      });
    },
  },
};
